import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiAmersfoortSchipholPage() {
  return (
    <CityAirportTemplate
      city="Amersfoort"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={67.50}
      distance="58 km"
      duration="45-50 minuten"
    />
  );
}
